/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgTable = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m1.75 3.5-.5.5v9l.5.5h12.5l.5-.5V4l-.5-.5H1.75Zm.5 4H5.5v2H2.25v-2Zm3.25 3H2.25v2H5.5v-2Zm1 2v-2h7.25v2H6.5Zm0-3v-2h7.25v2H6.5Zm0-3h7.25v-2H6.5v2Zm-1-2H2.25v2H5.5v-2Z"
}));

export default SvgTable;